/* eslint-disable no-use-before-define,jsx-a11y/iframe-has-title */
import React from 'react'
import { getConfig, getBrand, hideModal } from '../twd'

export const Legacy = ({cusip}) => {

    let base = getConfig('bw_service_host') + '/' + getBrand()
    let src = `${base}/servlet/msrbhist/history.htm?p_cusip=${cusip}`

    return <React.Fragment>
    <div
        date-name="trade-history"
        className="modal-dialog">
    <div className="modal-content">

        <div className="modal-header">
            <button
                date-name="trade-history-close"
                className="close"
                aria-label="close"
                type="button"
                onClick={hideModal}>
            <i className="material-icons" aria-hidden="true">close</i>
            </button>

            <h4 className="modal-title large-header text-center">
                Trade History Details
            </h4>
            <div className="subhead" style={{textAlign:'center'}}>Source: FINRA TRACE/MSRB</div>
        </div>

        <div className="modal-body" style={{width:'100%'}}>
        <iframe
            date-name="trade-history-frame"
            src={src}
            marginHeight="0" marginWidth="0"
            frameBorder="0" scrolling="no"
            style={{height:'456px', width:'100%'}}
            />
        </div>

    </div></div>

    </React.Fragment>
}


